import { defineMessages } from 'react-intl';

export default defineMessages({
  instructionHeaderTitle: {
    id: 'app.containers.Video.InstructionsHeaders.Title',
    defaultMessage: 'Envio do vídeo',
  },
  instructionHeaderSubtitle: {
    id: 'app.containers.Video.InstructionsHeaders.Subitle',
    defaultMessage: 'Carregue o vídeo',
  },
  instructionHeaderCardTitle: {
    id: 'app.containers.Video.InstructionsHeaders.CardTitle',
    defaultMessage: 'Requisitos para enviar o vídeo',
  },
  instructionHeaderCardDescription: {
    id: 'app.containers.Video.InstructionsHeaders.CardDescription',
    defaultMessage: '.',
  },
  instructionHeaderCardDescriptionItemRatio: {
    id: 'app.containers.Video.InstructionsHeaders.CardDescriptionItemRatio',
    defaultMessage: 'Ratio ',
  },
  instructionHeaderCardDescriptionItemRatioNumber: {
    id: 'app.containers.Video.InstructionsHeaders.CardDescriptionItemRatioNumber',
    defaultMessage: '3:2',
  },
  instructionHeaderCardDescriptionItemWidth: {
    id: 'app.containers.Video.InstructionsHeaders.CardDescriptionItemWidth',
    defaultMessage: 'Largura mínima ',
  },
  instructionHeaderCardDescriptionItemWidthNumber: {
    id: 'app.containers.Video.InstructionsHeaders.CardDescriptionItemWidthNumber',
    defaultMessage: '1152px',
  },
  instructionHeaderCardDescriptionItemOrientation: {
    id: 'app.containers.Video.InstructionsHeaders.CardDescriptionItemOrientation',
    defaultMessage: 'O vídeo deve estar na ',
  },
  instructionHeaderCardDescriptionItemHorizontal: {
    id: 'app.containers.Video.InstructionsHeaders.CardDescriptionItemHorizontal',
    defaultMessage: 'horizontal',
  },
  instructionHeaderCardDescriptionItemVideo: {
    id: 'app.containers.Video.InstructionsHeaders.CardDescriptionItemVideo',
    defaultMessage: 'Certifique-se de que você subiu o vídeo no YouTube antes de salvar o link',
  },
});

